import { useState } from 'react';
import { useTranslation } from '@shared/i18n';
import { useOrders } from '../hooks/useOrders';
import { OrderTable } from '../components/OrderTable';

export function OrdersPage() {
  const { t } = useTranslation();
  const [page, setPage] = useState(1);
  const { data, isLoading } = useOrders(page);

  return (
    <div className="space-y-4">
      <div className="flex items-center justify-between">
        <h2 className="text-xl font-semibold text-gray-900">{t('orders.title')}</h2>
        {data && (
          <span className="text-sm text-gray-500">
            {data.total} {t('orders.total_count')}
          </span>
        )}
      </div>

      <div className="card p-4">
        {isLoading ? (
          <div className="text-center py-8 text-gray-500">{t('orders.loading')}</div>
        ) : (
          <OrderTable orders={data?.orders ?? []} />
        )}
      </div>

      {data && data.totalPages > 1 && (
        <div className="flex items-center justify-center gap-2">
          <button
            onClick={() => setPage((p) => Math.max(1, p - 1))}
            disabled={page <= 1}
            className="btn btn-outline text-sm"
          >
            {t('common.previous')}
          </button>
          <span className="text-sm text-gray-600">
            {t('common.page')} {page} {t('common.of')} {data.totalPages}
          </span>
          <button
            onClick={() => setPage((p) => Math.min(data.totalPages, p + 1))}
            disabled={page >= data.totalPages}
            className="btn btn-outline text-sm"
          >
            {t('common.next')}
          </button>
        </div>
      )}
    </div>
  );
}
